<template>
     <div class="servicerequest-search">
          <PageTitle 
                icon="fa fa-clone" 
                main="Record" sub="Service Request" 
                />
            <b-form 
                v-show="mode === 'save' || mode === 'remove' || mode === 'read'" >
             <input 
                id="servicerequest-id" 
                type="hidden" 
                v-model="servicerequest.id" />
             <b-row>
                <b-col md="2" sm="12">
                    <b-form-group
                    label="Request Date:"
                    label-for="servicerequest-date_service_request"
                    >
                    <b-form-input
                    id="servicerequest-date_service_request"
                    type="date"
                    v-model="servicerequest.date_service_request"
                    :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                    size="sm"
                    />
                    </b-form-group>
                </b-col>
                <b-col md="5" sm="12">
                    <b-form-group 
                        label="Requester:" 
                        label-for="servicerequest-tenant_id_service_request">
                        <b-select 
                            id="servicerequest-tenant_id_service_request"
                            size="sm"
                            ref="searchFocus"
                            @input="loadImmobiles()"
                            :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            :options="tenants" 
                            v-model="servicerequest.tenant_id_service_request" 
                            />
                </b-form-group>
                </b-col> 
                <b-col md="5" sm="12">
                    <b-form-group 
                        label="Service:" 
                        label-for="servicerequest-default_service_type_id_service_request">
                        <b-select 
                            id="servicerequest-default_service_type_id_service_request"
                            size="sm"
                            :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            :options="defaultservicetypes" 
                            v-model="servicerequest.default_service_type_id_service_request" 
                            />
                    </b-form-group>
                </b-col> 
              
             </b-row>
             <b-row>
                <b-col md="8" sm="12">
                    <b-form-group 
                        label="Property:" 
                        label-for="servicerequest-immobile_id_service_request">
                        <b-select 
                            id="servicerequest-immobile_id_service_request"
                            size="sm"
                            :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            :options="immobiles" 
                            v-model="servicerequest.immobile_id_service_request" 
                            />
                    </b-form-group>
                </b-col> 
             </b-row>
             <b-row>
                 <b-col md="6" sm="12">
                        <b-form-group 
                            label="Comments:" 
                            label-for="servicerequest-comments_service_request">
                        <b-form-textarea id="servicerequest-comments_service_request"
                            :rows="3"
                            :max-rows="6"
                            size="sm"
                            v-model="servicerequest.comments_service_request"
                            :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            placeholder="Comments" />
                    </b-form-group>
                </b-col>
          
             </b-row>
              <b-card class="ownercontract-search-card" >
                 <b-tabs card >
                      <b-tab title="Order Service" active>
                          <b-table 
                class="table-responsive" 
                hover 
                 head-variant="dark" 
                :items="orderservices" 
                :fields="fieldsOrderService">
               <template v-slot:cell(actions)="data">
                    <b-button  
                        title = "Edit" 
                        size="sm" 
                        variant="light" 
                        @click="[loadOrderService(data.item),openModalOrderService()]" 
                        class="mr-2 mt-2">
                        <i class="fa fa-pencil"></i>
                    </b-button>
                </template>    
         </b-table> 
                      </b-tab>
                 </b-tabs>
              </b-card>
          
        <br>
         </b-form>

            <hr v-show="mode === 'save'">
              <b-row>
                <b-col xs="12">
                   <b-button  
                        size="sm" 
                        variant="light" 
                        title="Add"
                        class="mt-2  mb-2 fa fa-plus" 
                        v-show="mode !== 'save' && mode !== 'remove'"
                        @click="alterModo">
                    </b-button>
                    <b-button 
                        size="sm" 
                        variant="light"
                         title="Save"
                        class="mt-2 mb-2 ml-2 fa fa-save" 
                        v-if="mode === 'save'"
                        @click="save">
                        </b-button>
                    <b-button 
                        size="sm" 
                        variant="light" 
                         title="Delete"
                        class="mt-2 mb-2 ml-2 fa fa-trash" 
                        v-if="mode === 'remove'"
                        @click="remove">
                    </b-button>
                    <b-button 
                        size="sm" 
                        btn-sm 
                        variant="light" 
                         title="Back"
                        class="mt-2 mb-2 ml-2 fa fa-mail-reply"  
                        v-if="mode === 'remove' || mode === 'save' || mode === 'read' "
                        @click="reset">
                    </b-button>
                    <b-button 
                         size="sm" 
                         class="mt-2 mb-2 ml-2 fa" 
                          title="Search"
                         :class="icon" 
                         @click="[loadOwnerContracts(),toggleBusy(),showTable = !showTable]" 
                         variant="light" >
                    </b-button>
                </b-col>
            </b-row>
            <br>
            <b-row v-show="mode !== 'save' && mode !== 'remove'">
                   <div class="col-sm-4">
                    <div class="form-group">
                        <input 
                            type="text" 
                            size="sm" 
                            icon="search" 
                            v-model="search" 
                            
                              v-show="mode !== 'save' && mode !== 'remove'"
                            placeholder="Search by requester name" 
                            class="form-control">
                    </div>
                </div>  
          <transition  name="slide" type="animation" appear>       
         <b-table 
                 :busy="isBusy"  
                class="table-responsive" 
                :per-page="perPage" 
                :current-page="currentPage" 
                hover 
                 head-variant="dark" 
                v-show="showTable"
                :items="filteredList" 
                :fields="fields">
                <template v-slot:table-busy>
                    <div class="text-center text-info my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                    </div>
                </template>
               <template v-slot:cell(actions)="data">
                    <b-button  
                        title = "Open Order Service" 
                        size="sm" 
                        variant="light" 
                        @click="[loadOwner(data.item, 'read'),openModalOrderService()]" 
                        class="mr-2 mt-2">
                        <i class="fa fa-plus"></i>
                    </b-button>
                    <b-button  
                        title = "View" 
                        size="sm" 
                        variant="light" 
                        @click="loadOwner(data.item, 'read')" 
                        class="mr-2 mt-2">
                        <i class="fa fa-drivers-license-o"></i>
                    </b-button>
                    <b-button  
                        title = "Edit" 
                        size="sm" 
                        variant="light" 
                        @click="loadOwner(data.item)" 
                        class="mr-2 mt-2">
                        <i class="fa fa-pencil"></i>
                    </b-button>
                     <b-button  
                        title = "Delete" 
                        size="sm" 
                        variant="light" 
                        @click="loadOwner(data.item, 'remove')" class="mr-2 mt-2">
                        <i class="fa fa-trash"></i>
                    </b-button>
                </template>    
         </b-table> 
          </transition>
          <transition  name="slide" type="animation" appear>
            <b-pagination
                v-show="showTable"
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
                size="sm"
                aria-controls="my-table"
            ></b-pagination>
          </transition>
    </b-row>
    <b-modal
            id="modalOrderService"
            ref="modal"
            title-tag="h6"
            title="Order Service"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="saveOrderService"
        >
          <b-form>
              <b-row>
                <b-col md="4" sm="12">
                    <b-form-group
                        label="Order Date:"
                        label-for="orderservice-date_order_service"
                        >
                        <b-form-input
                        id="orderservice-date_order_service"
                        type="date"
                        v-model="orderservice.date_order_service"
                        size="sm"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="4" sm="12">
                    <b-form-group
                        label="Date Scheduled:"
                        label-for="orderservice-date_scheduled_order_service"
                        >
                        <b-form-input
                        id="orderservice-date_scheduled_order_service"
                        type="date"
                        v-model="orderservice.date_scheduled_order_service"
                        size="sm"
                        />
                    </b-form-group>
                </b-col>
                 <b-col md="4" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                            <input class="form-check-input" 
                                v-model="orderservice.service_payment_fixed_order_service" 
                                true-value="1" false-value="0" 
                                type="checkbox" 
                                id="orderservice-service_payment_fixed_order_service"
                            >
                            <label class="form-check-label" for="orderservice-service_payment_fixed_order_service">
                                Paid service (Fixed Value)?
                            </label>
                        </div>
                    </div>
                </b-col>  
              </b-row>
              <b-row>
                <b-col md="12" sm="12">
                        <b-form-group
                            label="Service Provider Contract:"
                            label-for="orderservice-service_provider_contract_item_id_order_service"
                        >
                            <b-form-select
                                id="orderservice-service_provider_contract_item_id_order_service"
                                size="sm"
                                :options="serviceprovidecontractitems"
                                v-model="orderservice.service_provider_contract_item_id_order_service"
                            />
                        </b-form-group>
                    </b-col>
              </b-row>
              <b-row>
                 <b-col md="12" sm="12">
                        <b-form-group 
                            label="Comments:" 
                            label-for="orderservice-comments_order_service">
                        <b-form-textarea id="orderservice-comments_order_service"
                            :rows="3"
                            :max-rows="6"
                            size="sm"
                            v-model="orderservice.comments_order_service"
                            placeholder="Comments" />
                    </b-form-group>
                </b-col>
          
             </b-row>
          </b-form>
        </b-modal>         
     </div>
</template>

<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import PageTitle from '../template/PageTitle'

var moment = require('moment-timezone')

export default {
    name: 'ServiceRequestSearch',
    components: {PageTitle },
    data: function() {
        return {
                mode: 'insert',
                search: '',
                servicerequest: {},
                servicerequestitem: {},
                orderservice:{},
                immobile: {},
                servicerequestitems:[],
                orderservices:[],
                defaultservicetypes:[],
                servicerequests: [],
                tenants:[],
                immobiles: [],
                servicerequestcontracts:[],
                serviceprovidecontracts:[],
                serviceprovidecontractitems:[],
                perPage: 5,
                currentPage: 1,
                 isBusy: false,
                 showTable: false,
                headerBgVariant: 'dark',
                headerTextVariant: 'light',
                bodyBgVariant: 'light',
                bodyTextVariant: 'dark',
                footerBgVariant: 'warning',
                footerTextVariant: 'dark',
                fields: [
                {
                        key: 'date_service_request',label: 'Request Date',sortable: true,
                            formatter: value =>
                            value ? moment.utc(value).format('MM-DD-YYYY') : '',variant: 'light'
                    },
                     { key: 'confirmed_service_request', label: 'Confirmed', sortable: false,
                        formatter: value => value ? 'Yes' : 'No' ,variant: 'light'},
                    { key: 'name_default_service_type', label: 'Service', sortable: false ,variant: 'light'},
                    { key: 'name_tenant', label: 'Requester', sortable: false ,variant: 'light'},
                    { key: 'address_immobile', label: 'Property', sortable: false ,variant: 'light'},
                    { key: 'region_immobile', label: 'Region', sortable: false ,variant: 'light'},
                    { key: 'name_type_part_immobile', label: 'Location', sortable: false ,variant: 'light'},
                    { key: 'name_owner', label: 'Landlord', sortable: false ,variant: 'light'},
                    { key: 'comments_service_request', label: 'Comments', sortable: false ,variant: 'light'},
               
                { key: 'actions', label: 'Action',variant: 'light' },
                //{ key: 'accesses', label: 'Acessos',variant: 'secondary' }
                ],
                fieldsOrderService:[
                    { key: 'number_order_service', label: 'Nº', sortable: false ,variant: 'light'},
                    {
                      key: 'date_order_service',label: 'Order Date',sortable: true,
                            formatter: value =>
                            value ? moment.utc(value).format('MM-DD-YYYY') : '',variant: 'light'
                    },
                     {
                        key: 'date_scheduled_order_service',label: 'Date Scheduled',sortable: true,
                            formatter: value =>
                            value ? moment.utc(value).format('MM-DD-YYYY') : '',variant: 'light'
                    },
                    { key: 'name_service_provider', label: 'Service Provider', sortable: false ,variant: 'light'},
                    { key: 'service_payment_fixed_order_service', label: 'Service Value Fixed', sortable: false,
                        formatter: value => value ? 'Yes' : 'No' ,variant: 'light'},     
                    { key: 'name_service_provider', label: 'Service Provider', sortable: false ,variant: 'light'},
                    { key: 'comments_order_service', label: 'Comments', sortable: false ,variant: 'light'},
                    { key: 'actions', label: 'Action',variant: 'light' },
               
                ]
               
            }
        },
        computed: {
            filteredList() {
                return this.servicerequests.filter(servicerequest => {
                    return servicerequest.name_tenant.toLowerCase().includes(this.search.toLowerCase())
                    })
            },
            compan(){
                return this.$store.state.compan
            },
            icon() {
            return this.showTable ? "fa-retweet" : "fa-search";
            },
            rows() {
                return this.servicerequests.length
            },
            user(){
                    return this.$store.state.user
            },
        },
        methods:{
            formatDateTime(date) {
                return moment(date)
                    .utcOffset(-3)
                    .format('YYYY-MM-DD LT')
            },
            formatDate(value) {
                return moment(value)
                    .format('YYYY-MM-DD')
            },
            toggleBusy() {
                this.isBusy = !this.isBusy
            },
            loadOwnerContracts(){
                const url = `${baseApiUrl}/servicerequestsbycompany/${this.compan.id}`
                axios(url).then(res =>{
                     this.servicerequests = res.data
                      this.isBusy = false
                })
            },
            loadTenants(){
                const url = `${baseApiUrl}/tenentsbycompany/${this.compan.id}`
                axios(url).then(res =>{
                     this.tenants = res.data.map(type => {
                        return { value: type.id, text: type.name_tenant }
                    })
                
                })
            },
            alterModo() {
                    this.mode = 'save'
                    this.servicerequest = {}
                    this.servicerequest.date_service_request = this.formatDate(Date())
                    this.$refs.searchFocus.focus();
            },
             reset() {
                this.mode = 'insert'
                this.loadOwnerContracts()              
                this.servicerequest = {}
            },
            async save() {

                const method = this.servicerequest.id ? 'put' : 'post'
                const id = this.servicerequest.id ? `/${this.servicerequest.id}` : ''

                if(this.servicerequest.id){
                    this.servicerequest.update_date_service_request = this.formatDateTime(Date())
                    this.servicerequest.update_user_service_request = this.user.id
                }else{
                    this.servicerequest.user_id_service_request = this.user.id
                    this.servicerequest.company_id_service_request = this.compan.id
                }

                await axios[method](`${baseApiUrl}/servicerequests${id}`, this.servicerequest)
                    .then(() => {
                        this.$toasted.global.defaultSuccess()
                        this.reset()
                    })
                    .catch(showError)
            },
            remove() {
                    const id = this.servicerequest.id
                    axios.delete(`${baseApiUrl}/servicerequests/${id}`)
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.reset()
                        })
                        .catch(showError)
            },
            loadOwner(servicerequest, mode = 'save') {
                this.mode = mode
                 if(servicerequest.date_service_request) servicerequest.date_service_request = this.formatDate(servicerequest.date_service_request)
                this.servicerequest = { ...servicerequest }
                this.$refs.searchFocus.focus();
                this.loadServiceProviderContract()
                this.loadOrderServices()
                this.orderservice = {}

            },
            loadDefaultServiceRequests() {
                const url = `${baseApiUrl}/defaultservicetypesbycompany/${this.compan.id}`
                axios.get(url).then(res => {
                    this.defaultservicetypes = res.data.map(type => {
                        return { value: type.id, text: type.name_default_service_type }
                    })
                })
            },
            loadImmobiles() {
                const url = `${baseApiUrl}/tenantagreementbytenant/${this.servicerequest.tenant_id_service_request}`
                axios.get(url).then(res => {
                    this.immobiles = res.data.map(type => {
                        return { value: type.id, text: type.address_immobile + ' , ' + type.region_immobile + ' - ' +  type.name_type_part_immobile + ' - Landlord ' + type.name_owner  }
                    })
                })
            },
            openModalOrderService(){

                this.orderservice.date_order_service =  moment().format(
                'YYYY-MM-DD'
            )
                this.$bvModal.show('modalOrderService')
            },
            loadServiceProviderContract() {
                 const url = `${baseApiUrl}/serviceprovidecontractitemsbydefaultservices/${this.compan.id}/?default_service_type_id=${this.servicerequest.default_service_type_id_service_request}`
                axios.get(url).then(res => {
                    this.serviceprovidecontractitems = res.data.map(type => {
                        return { value: type.id, text: type.name_service_provider + ' - Price: ' + ' Fixed: ' + type.fixed_value_contract_item + ' |' + ' Hourly: ' + type.hourly_rate_contract_item }
                    })
                })
            },
           async saveOrderService(){
                 const method = this.orderservice.id ? 'put' : 'post'
                const id = this.orderservice.id ? `/${this.orderservice.id}` : ''

                if(this.orderservice.id){
                    this.orderservice.update_date_order_service = this.formatDate(Date())
                    this.orderservice.update_user_order_service = this.user.id
                }else{
                    this.orderservice.user_id_order_service = this.user.id
                    this.orderservice.company_id_order_service = this.compan.id
                    this.orderservice.service_request_id_order_service = this.servicerequest.id
                }

                await axios[method](`${baseApiUrl}/orderservices${id}`, this.orderservice)
                    .then(() => {
                        this.$toasted.global.defaultSuccess()
                        this.reset()
                    })
                    .catch(showError)
            },
            loadOrderServices(){
                const url = `${baseApiUrl}/servicerequestsbyorderservice/${this.servicerequest.id}`
                axios(url).then(res =>{
                     this.orderservices = res.data
                })
            },
            loadOrderService(item){
                this.orderservice = {...item}
            },


        },
        mounted(){
            this.loadOwnerContracts()
            this.loadTenants()
            this.loadDefaultServiceRequests()
            this.showTable = true
        }
}
</script>

<style>


    .servicerequest-search{
        font-size: 0.75rem;
        color: white;
   
    }

    .servicerequest-search button{
        font-size: 0.75rem;
    }

     .servicerequest-search select{
        font-size: 0.75rem;
    }

    .servicerequest-search input{
        font-size: 0.75rem;
    }

    .servicerequest-search textarea{
            font-size: 0.75rem;
        }


    .servicerequest-search-card label{
        font-size: 0.75rem;
        color: black;
   
    }


     #modalOrderService button{
        font-size: 0.75rem;
    }

     #modalOrderService input{
        font-size: 0.75rem;
    }

      #modalOrderService select{
        font-size: 0.75rem;
    }

      #modalOrderService textarea{
        font-size: 0.75rem;
    }

      #modalOrderService label{
        font-size: 0.75rem;
        color: black;
    }

    




    
@keyframes slide-in {
  from {
    transform: translateY(40px);
  }
  to {
    transform: translateY(0);
  }
}

@keyframes slide-out {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(40px);
  }
}

.slide-enter-active {
  animation: slide-in 1s ease;
  transition: opacity 1s;
}

.slide-leave-active {
  animation: slide-out 1s ease;
  transition: opacity 1s;
}

.slide-enter,
.slide-leave-to {
  opacity: 0;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

</style>
